/** @param {Date} date */
export const dateHoursMinutes = (date) => moment(date).format('HH:mm');

/** @param {Date} date */
export const dateDayMonthnameYear = (date) => moment(date).format('D MMM YYYY');

/** @param {Date} date */
export const dateDayMonthShortYear = (date) => moment(date).format('DD.MM.YY');

/** @param {Number} seconds */
export const formatSecondsAsHoursAndMinutes = (seconds) => {
	return moment.duration(seconds, 'seconds').format('hh:mm:ss');
};
